module.exports = __webpack_public_path__ + "img/logo_ava.dd1c221a.png";